// a const object rather than an enum, so price simulation can keep comparing and indexing with the plain numbers in its own types
export const VossProductGroupType = { Optional: 0, Included: 1 } as const;
export type VossProductGroupType = (typeof VossProductGroupType)[keyof typeof VossProductGroupType];

export const VossProductGroupTypeText: Record<number, string> = {
    [VossProductGroupType.Optional]: 'vossProductGroupType.optional',
    [VossProductGroupType.Included]: 'vossProductGroupType.included',
};

export const productGroupTypes: VossProductGroupType[] = [VossProductGroupType.Included, VossProductGroupType.Optional];
